import React, { useState, useEffect } from "react";
import { IIncrementorProps } from "./IncrementorProps";
import { Container, InputWrapper, Counter } from "./IncrementorHelpers";

const Incrementor: React.FC<IIncrementorProps> = ({
  name,
  value,
  min = 0,
  max = 10,
  onChangeCount,
  index = 0,
}) => {
  const [incrementValue, setIncrementValue] = useState(value);
  const [minReached, setMinReached] = useState(value <= min);
  const [maxReached, setMaxReached] = useState(value >= max);

  useEffect(() => {
    if (value !== incrementValue) {
      setIncrementValue(value);
    }
    setMaxReached(value >= max);
    setMinReached(value <= min);
  }, [incrementValue, minReached, maxReached, value, min, max]);

  const handleIncrementClick = () => {
    onChangeCount(index, incrementValue + 1);
  };

  const handleIncrementKeyPress = (event: { key: any }) => {
    const code = event.key;
    if (!maxReached && (code === "Enter" || code === " ")) {
      onChangeCount(index, incrementValue + 1);
    }
  };

  const handleDecrementKeyPress = (event: { key: any }) => {
    const code = event.key;

    if (!minReached && (code === "Enter" || code === " ")) {
      onChangeCount(index, incrementValue - 1);
    }
  };

  const handleDecrementClick = () => {
    onChangeCount(index, incrementValue - 1);
  };
  // const onChange = () => {
  //   // Placeholder function to prevent eslint warning on input field.
  // };

  const incrementPointerEvents = maxReached ? "none" : "initial";
  const decrementPointerEvents = minReached ? "none" : "initial";

  return (
    <Container className="d-flex justify-content-between align-items-center">
      <Counter
        class="decrease"
        onClick={handleDecrementClick}
        onKeyPress={handleDecrementKeyPress}
        style={{ pointerEvents: decrementPointerEvents }}
      >
        <a
          aria-label={`Decrease ${name}`}
          id={`decrease-${name}`}
          role="button"
          tabIndex={0}
        >
          <span>–</span>
        </a>
      </Counter>
      <InputWrapper>
        <input
          className={`increment`}
          name={name}
          id={name}
          type="text"
          value={incrementValue}
          // onChange={onChange}
          placeholder={`${incrementValue}`}
          aria-label="Increment"
          tabIndex={-1}
          readOnly
        />
      </InputWrapper>
      <Counter
        class="increase"
        onClick={handleIncrementClick}
        onKeyPress={handleIncrementKeyPress}
        style={{ pointerEvents: incrementPointerEvents }}
      >
        <a
          aria-label={`Increase ${name}`}
          id={`increase-${name}`}
          tabIndex={0}
          role="button"
        >
          <span>+</span>
        </a>
      </Counter>
    </Container>
  );
};

export default Incrementor;
